import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import { Row, Col, Card, Collapse, theme } from 'antd';
const text = `
لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
`;
const getItems = (panelStyle) => [
  {
    key: '1',
    label: 'متن سوال شماره اول',
    children: <p>{text}</p>,
    style: panelStyle,
  },
  {
    key: '2',
    label: 'متن سوال شماره دوم',
    children: <p>{text}</p>,
    style: panelStyle,
  },
  {
    key: '3',
    label: 'متن سوال شماره سوم',
    children: <p>{text}</p>,
    style: panelStyle,
  },
];


const FAQs = () => {  

  const { token } = theme.useToken();
  const panelStyle = {
    fontWeight:"normal",
    marginBottom: 24,
    background: "-moz-linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
background: "-webkit-linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
background: "linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  return (  
    <Row  align={"center"}>  
      <Col span={24} style={{ maxWidth: "1200px" }}>  

        <Card 
          className="fEstedad light-glass-effect-card shaped-border"   
          title="سوالات متداول"   
          style={{ display: "flex", flexDirection: 'column', justifyContent: 'center'}}
        >  
          <p className="font-3 fYekan p-2" style={{textAlign:"justify"}}>

          <Collapse
      bordered={false}
      defaultActiveKey={['1']}
      expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 180} />}
      style={{
        background: "none",
      }}
      items={getItems(panelStyle)}
    />

          </p>
        </Card>  

      </Col>  
    </Row>  
  );  
};  

export default FAQs;  